import { gql } from '@apollo/client';

export const URL_ARRAY_GET_STORAGE_READ_SIGNED_URL = gql`
  query urlArrayGetStorageReadSignedURL($data: URLArrayGetStorageReadSignedURLInput) {
    urlArrayGetStorageReadSignedURL(data: $data) {
      url
    }
  }
`;
